import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../services/api"; // ✅ يستخدم interceptor جلب توكن Firebase تلقائياً
import "../styles/ManageBanners.css";

const Announcements = ({ courseId }) => {
  const [announcements, setAnnouncements] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);

  const [formData, setFormData] = useState({
    title: "",
    content: "",
    is_pinned: false,
  });

  useEffect(() => {
    fetchAnnouncements();
  }, [courseId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchAnnouncements = async () => {
    try {
      setLoading(true);
      const res = await api.get(`/courses/${courseId}/announcements`);
      setAnnouncements(res.data.announcements || []);
    } catch (err) {
      toast.error("فشل في جلب الإعلانات");
    } finally {
      setLoading(false);
    }
  };

  const openAddModal = () => {
    setEditingItem(null);
    setFormData({ title: "", content: "", is_pinned: false });
    setShowModal(true);
  };

  const openEditModal = (item) => {
    setEditingItem(item);
    setFormData({
      title: item.title || "",
      content: item.content || "",
      is_pinned: !!item.is_pinned,
    });
    setShowModal(true);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("هل أنت متأكد من حذف هذا الإعلان؟")) return;
    try {
      await api.delete(`/courses/${courseId}/announcements/${id}`);
      toast.success("تم حذف الإعلان بنجاح");
      fetchAnnouncements();
    } catch (err) {
      toast.error("فشل الحذف");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingItem) {
        await api.put(`/courses/${courseId}/announcements/${editingItem.id}`, formData);
        toast.success("تم تحديث الإعلان");
      } else {
        await api.post(`/courses/${courseId}/announcements`, formData);
        toast.success("تم نشر الإعلان بنجاح 📢");
      }
      setShowModal(false);
      fetchAnnouncements();
    } catch (err) {
      toast.error(err.response?.data?.message || "حدث خطأ أثناء الحفظ");
    }
  };

  const formatDate = (dateStr) => {
    try {
      return new Date(dateStr).toLocaleString("ar-SA", {
        year: "numeric", month: "short", day: "numeric",
        hour: "2-digit", minute: "2-digit",
      });
    } catch {
      return dateStr;
    }
  };

  if (loading) return <div className="loading-spinner">⏳ جارٍ تحميل الإعلانات...</div>;

  return (
    <div className="manage-banners-page">
      <div className="banners-header">
        <h2>📢 إعلانات الدورة</h2>
        <button className="add-btn" onClick={openAddModal}>
          + إعلان جديد
        </button>
      </div>

      <p className="banners-hint">
        تُعرض هذه الإعلانات للطلاب في تبويب "الإعلانات 📢" داخل صفحة تفاصيل الدورة في التطبيق. يمكنك تثبيت الإعلانات الهامة لتظهر في الأول.
      </p>

      {announcements.length === 0 ? (
        <div className="empty-state">
          <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>📭</div>
          <p>لا توجد إعلانات حتى الآن. أضف أول إعلان لطلابك!</p>
        </div>
      ) : (
        <div className="banners-grid" style={{ gridTemplateColumns: "1fr" }}>
          {announcements.map((item) => (
            <div
              key={item.id}
              className="banner-card"
              style={{
                borderRight: item.is_pinned ? "4px solid #F59E0B" : "4px solid #6366F1",
                background: item.is_pinned ? "linear-gradient(135deg, #fffbeb, #fff)" : undefined,
              }}
            >
              <div style={{ padding: "1.25rem" }}>
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "1rem" }}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", marginBottom: "0.5rem" }}>
                      {item.is_pinned && (
                        <span style={{
                          background: "#FEF3C7", color: "#D97706",
                          padding: "2px 10px", borderRadius: "20px",
                          fontSize: "0.78rem", fontWeight: 700
                        }}>
                          📌 هام
                        </span>
                      )}
                      <h3 style={{ margin: 0, fontSize: "1.05rem", fontWeight: 700, color: "#111827" }}>
                        {item.title}
                      </h3>
                    </div>
                    <p style={{ margin: "0 0 0.75rem", color: "#374151", lineHeight: 1.6, fontSize: "0.95rem" }}>
                      {item.content}
                    </p>
                    <span style={{ fontSize: "0.8rem", color: "#9CA3AF" }}>
                      🕐 {formatDate(item.created_at)}
                    </span>
                  </div>
                  <div className="actions-right" style={{ flexShrink: 0 }}>
                    <button className="edit-btn" onClick={() => openEditModal(item)}>✏️ تعديل</button>
                    <button className="delete-btn" onClick={() => handleDelete(item.id)}>🗑️ حذف</button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content banners-modal">
            <h3>{editingItem ? "تعديل الإعلان" : "إعلان جديد 📢"}</h3>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>عنوان الإعلان</label>
                <input
                  type="text"
                  required
                  value={formData.title}
                  onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                  placeholder="مثال: تأجيل الامتحان إلى الخميس"
                />
              </div>

              <div className="form-group">
                <label>محتوى الإعلان</label>
                <textarea
                  required
                  rows={4}
                  value={formData.content}
                  onChange={(e) => setFormData({ ...formData, content: e.target.value })}
                  placeholder="اكتب نص الإعلان بالتفصيل هنا..."
                  style={{
                    width: "100%", padding: "0.75rem", borderRadius: "10px",
                    border: "1px solid #e5e7eb", fontFamily: "Tajawal, sans-serif",
                    fontSize: "0.95rem", resize: "vertical", direction: "rtl",
                  }}
                />
              </div>

              <div className="form-group checkbox-group">
                <label style={{ display: "flex", alignItems: "center", gap: "0.5rem", cursor: "pointer" }}>
                  <input
                    type="checkbox"
                    checked={formData.is_pinned}
                    onChange={(e) => setFormData({ ...formData, is_pinned: e.target.checked })}
                    style={{ width: "18px", height: "18px" }}
                  />
                  <span>📌 تثبيت كإعلان هام (يظهر أولاً وبتمييز مميز)</span>
                </label>
              </div>

              <div className="modal-actions">
                <button type="button" className="cancel-btn" onClick={() => setShowModal(false)}>إلغاء</button>
                <button type="submit" className="save-btn">📢 نشر الإعلان</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Announcements;
